"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".container[_ngcontent-%COMP%]{padding:30px;position:relative}.container[_ngcontent-%COMP%]   .left-actions[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;height:36px;min-width:0}.value[_ngcontent-%COMP%]{display:flex;align-items:center}"];
exports.styles = styles;
